export default "/unterm2/js/webpack/webfonts/Noto Kufi Arabic Regular.ttf";